import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { ROEReport } from "../../../components/Reports/ROEReport";

export interface IROEReportPage {}

export const ROEReportPage: FC<IROEReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="ROE Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<ROEReport />}
		/>
	);
};
